import { AxialPoint } from "./AxialPoint";
import { CubePoint } from "./CubePoint";
import { OffsetPoint } from "./OffsetPoint";
import { PixelPoint } from "./PixelPoint";
export var PickingInfoPoint;
(function (PickingInfoPoint) {
    // Conversions
    PickingInfoPoint.toAxialPoint = (point) => PixelPoint.toAxialPoint(PickingInfoPoint.toPixelPoint(point));
    PickingInfoPoint.toCubePoint = (point) => PixelPoint.toCubePoint(PickingInfoPoint.toPixelPoint(point));
    PickingInfoPoint.toOffsetPoint = (point) => PixelPoint.toOffsetPoint(PickingInfoPoint.toPixelPoint(point));
    PickingInfoPoint.toPixelPoint = ([x, y]) => ({ x, y });
    // Rounded Conversions
    PickingInfoPoint.toRoundedAxialPoint = (point) => AxialPoint.round(PickingInfoPoint.toAxialPoint(point));
    ;
    PickingInfoPoint.toRoundedCubePoint = (point) => CubePoint.round(PickingInfoPoint.toCubePoint(point));
    PickingInfoPoint.toRoundedOffsetPoint = (point) => OffsetPoint.round(PickingInfoPoint.toOffsetPoint(point));
})(PickingInfoPoint || (PickingInfoPoint = {}));
//# sourceMappingURL=PickingInfoPoint.js.map